module.exports = __webpack_public_path__ + "images/device.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/device.png
// module id = 957
// module chunks = 2